// @ts-nocheck

export default function Testimonials() {
  return (
    <>
<section className="testi-sec">
  <div className="testi-header">
    <div className="testi-hdr-grid">
      <div>
        <div className="ey rev">05 / We&apos;re new</div>
        <h2 className="sh2 rev d1">No fake quotes.{" "}<br /><em>Be one of our first.</em></h2>
      </div>
      <p className="testi-sub rev d2">
        LexVio is launching this quarter. We&apos;re onboarding founders, litigators, in-house counsel, and SMBs as design partners. If you want to shape what we ship next — and have your story featured here when we do — get in touch.
      </p>
    </div>
  </div>
  <div className="tgrid">
    <a className="tcard" data-tilt="true" href="/scan" style={{textDecoration:"none",color:"inherit",cursor:"pointer"}}>
      <div className="tc-persona">For founders</div>
      <p className="tc-q">&ldquo;Try it on your next term sheet, SAFE note, or vendor agreement. Free. No card.&rdquo;</p>
      <div className="tc-name">Start a free scan</div>
      <div className="tc-role" style={{color:"var(--cu)"}}>Open the scanner &rarr;</div>
    </a>
    <a className="tcard" data-tilt="true" href="/contact" style={{transitionDelay:".11s",textDecoration:"none",color:"inherit",cursor:"pointer"}}>
      <div className="tc-persona">For litigators &amp; counsel</div>
      <p className="tc-q">&ldquo;Become a design partner. Get priority feature requests, early access, and a discount that doesn&apos;t expire.&rdquo;</p>
      <div className="tc-name">Apply as a partner</div>
      <div className="tc-role" style={{color:"var(--cu)"}}>Tell us about your practice &rarr;</div>
    </a>
    <a className="tcard" data-tilt="true" href="/contact" style={{transitionDelay:".22s",textDecoration:"none",color:"inherit",cursor:"pointer"}}>
      <div className="tc-persona">For SMBs &amp; law firms</div>
      <p className="tc-q">&ldquo;Pilot LexVio with your team. We&apos;ll help you onboard, and we&apos;ll listen to what you need.&rdquo;</p>
      <div className="tc-name">Request a pilot</div>
      <div className="tc-role" style={{color:"var(--cu)"}}>30-minute scoping call &rarr;</div>
    </a>
  </div>
</section>


    </>
  );
}
